import { useCallback, useContext } from 'react'

import { UploadProgressContext } from '../context/UploadProgressContext'

export const useUploadFileActions = (uploadId: string) => {
  const context = useContext(UploadProgressContext)

  const cancelUpload = useCallback(() => {
    context.cancelUpload(uploadId)
  }, [context, uploadId])

  const retryUpload = useCallback(async () => {
    await context.retryUpload(uploadId)
  }, [context, uploadId])

  return {
    cancelUpload,
    retryUpload
  }
}
